export enum PfcSensorNameEnum {
  POTENTIAL_FREE_CONTACT = 'Potentialfreier Kontakt '
}
